import { jsx as _jsx } from "react/jsx-runtime";
var FullscreenOff = function FullscreenOff(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M13.9976 10.9754C13.4476 10.9724 13.0026 10.5264 13.0026 9.97643L12.9996 5.00143C12.9986 4.44943 13.4466 4.00043 13.9986 4.00043H13.9996C14.5516 4.00043 14.9986 4.44843 14.9996 4.99943L15.0016 7.58443L18.2926 4.29343C18.4876 4.09843 18.7436 4.00043 18.9996 4.00043C19.2546 4.00043 19.5106 4.09843 19.7066 4.29343C20.0966 4.68443 20.0966 5.31743 19.7066 5.70743L16.4266 8.98743L19.0036 9.00043C19.5566 9.00343 20.0026 9.45443 19.9996 10.0054C19.9966 10.5564 19.5486 11.0004 18.9996 11.0004H18.9946L13.9976 10.9754ZM5.70725 19.7068C5.31625 20.0978 4.68425 20.0978 4.29325 19.7068C3.90225 19.3158 3.90225 18.6838 4.29325 18.2928L7.58525 15.0008L5.00025 14.9998C4.44725 14.9998 4.00025 14.5518 4.00025 13.9988C4.00125 13.4468 4.44825 12.9998 5.00025 12.9998H5.00125L9.97625 13.0028C10.5263 13.0028 10.9723 13.4478 10.9753 13.9978L11.0003 18.9948C11.0033 19.5468 10.5573 19.9968 10.0052 19.9998H10.0003C9.45025 19.9998 9.00325 19.5558 9.00025 19.0048L8.98725 16.4268L5.70725 19.7068Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default FullscreenOff;